import React from 'react';

const LEVEL_COLOR = { 身强: '#2e7d32', 偏强: '#558b2f', 中和: '#8d6e63', 偏弱: '#ef6c00', 身弱: '#c62828' };

function FlagChip({ label, data }) {
  const icon = data.ok === 2 ? '✓✓' : data.ok === 1 ? '△' : '✗';
  const cls = data.ok === 2 ? 'good' : data.ok === 1 ? 'mid' : 'bad';
  return (
    <span className={`st-flag ${cls}`} title={data.text}>
      <b>{label}</b><i>{icon}</i>
    </span>
  );
}

export default function StrengthPanel({ strength, dayGan }) {
  if (!strength) return null;
  const { level, ratio, samePts, diffPts, deLing, deDi, deShi, favor, favorPlain, levelPlain, note } = strength;
  const pct = Math.round(ratio * 100);
  return (
    <section className="panel bz-panel st-panel">
      <h4 className="sec-title">日主强弱 · 旺衰分析（日主 {dayGan}）</h4>
      <div className="st-grid">
        {/* 左：等级与能量条 */}
        <div className="st-left">
          <div className="st-level" style={{ borderColor: LEVEL_COLOR[level], color: LEVEL_COLOR[level] }}>
            <b>{level}</b>
            <small>帮扶 {pct}% ：克泄耗 {100 - pct}%</small>
          </div>
          <div className="st-bar" title={`同党(印比帮身) ${samePts}分 / 异党(克泄耗) ${diffPts}分`}>
            <div className="st-bar-same" style={{ width: `${pct}%` }} />
          </div>
          <div className="st-bar-legend">
            <span style={{ color: LEVEL_COLOR[level] }}>■ 同党（比劫帮身＋印星生身）{samePts}分</span>
            <span style={{ color: '#999' }}>■ 异党（官杀克＋财星耗＋食伤泄）{diffPts}分</span>
          </div>

          <p className="pd-plain">💬 白话：<b>{levelPlain}</b></p>
        </div>

        {/* 右：三要素 + 喜用 */}
        <div className="st-right">
          <div className="st-flags">
            <FlagChip label="得令（月令）" data={deLing} />
            <FlagChip label="得地（通根）" data={deDi} />
            <FlagChip label="得势（帮身）" data={deShi} />
          </div>
          <ul className="st-detail">
            <li>{deLing.text}</li>
            <li>{deDi.text}</li>
            <li>{deShi.text}</li>
          </ul>
          <div className="st-favor">
            <b>喜用方向：</b>
            {favor.map((f) => <em key={f}>{f}</em>)}
            <p className="pd-plain">💬 {favorPlain}</p>
          </div>
        </div>
      </div>
      <p className="bz-tip">{note}</p>
    </section>
  );
}
